import { JDSMegaMenuInternalProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSMegaMenuInternalProps>
  ): React.FC<JDSMegaMenuInternalProps> =>
  (props: JDSMegaMenuInternalProps) => {
    return <Component {...props} />;
  };
